import React from 'react'
import { useParams } from 'react-router-dom'
import BudgetPlanningForm from './BudgetPlanningForm'

const BudgetPlanningView = () => {
  const { id } = useParams()
  
  return <BudgetPlanningForm mode="view" budgetId={id} />
}

export default BudgetPlanningView

